import { httpGet } from '@/api/httpClient';

export type ZipatoDeviceLite = { uuid: string; name: string | null };
export type DbDeviceLite = { id: number; uuid: string; name: string };

export type SuperZipatoDevicesBoxResult = {
  boxId: number;
  boxUuid: string;
  boxName: string;
  zipatoDevicesCount: number;
  dbDevicesCount: number;
  toImport: ZipatoDeviceLite[];
  toDelete: DbDeviceLite[];
  nameMismatch: { uuid: string; dbName: string; zipatoName: string }[];
};

export type SuperZipatoDevicesResponse = {
  projectId: number;
  generatedAt: string;
  global: {
    zipatoDevicesCount: number;
    dbDevicesCount: number;
    toImportCount: number;
    toDeleteCount: number;
    nameMismatchCount: number;
  };
  boxes: SuperZipatoDevicesBoxResult[];
};

export type ZipatoAttributeLite = {
  uuid: string;
  name: string | null;
  deviceUuid: string | null;
  deviceName: string | null;
  attributeTypeCode: string | null;
};

export type DbAttributeLite = {
  id: number;
  uuid: string;
  name: string;
  deviceId: number;
  deviceUuid: string | null;
  deviceName: string;
};

export type SuperZipatoAttributesDeviceMismatch = {
  uuid: string;
  dbDeviceUuid: string;
  dbDeviceName: string;
  zipatoDeviceUuid: string;
  zipatoDeviceName: string | null;
};

export type SuperZipatoAttributesPerDeviceDiff = {
  deviceUuid: string;
  deviceNameZipato: string | null;
  deviceNameDb: string | null;
  missingOnDb: ZipatoAttributeLite[];
  extraOnDb: DbAttributeLite[];
};

export type SuperZipatoAttributesBoxResult = {
  boxId: number;
  boxUuid: string;
  boxName: string;
  zipatoAttributesCount: number;
  dbAttributesCount: number;
  missingOnDb: ZipatoAttributeLite[];
  extraOnDb: DbAttributeLite[];
  deviceMismatch: SuperZipatoAttributesDeviceMismatch[];
  devices: SuperZipatoAttributesPerDeviceDiff[];
};

export type SuperZipatoAttributesResponse = {
  projectId: number;
  generatedAt: string;
  global: {
    zipatoAttributesCount: number;
    dbAttributesCount: number;
    missingOnDbCount: number;
    extraOnDbCount: number;
    deviceMismatchCount: number;
  };
  boxes: SuperZipatoAttributesBoxResult[];
};

export const superZipatoAnalysisApi = {
  analyseDevices: (projectId: number) =>
    httpGet<SuperZipatoDevicesResponse>(`/admin/super-zipato-analysis/projects/${projectId}/devices`),
  analyseAttributes: (projectId: number) =>
    httpGet<SuperZipatoAttributesResponse>(`/admin/super-zipato-analysis/projects/${projectId}/attributes`),
};

